module.exports = __webpack_public_path__ + "images/application/team/brian-4288443c.jpg";